import { Link } from "react-router-dom";
import RemboLogo from "./RemboLogo";
import Icon from "./icons/Icon";

// Shared shell for every auth page. Desktop: an indigo brand panel beside the
// form card. Mobile: just a small logo header and the form. `wide` widens the
// card for the sign-up form.
export default function AuthLayout({ wide = false, footer, children }) {
  return (
    <div className="rl-auth">
      <aside className="rl-auth__panel" aria-hidden="true">
        <Link to="/" tabIndex={-1}><RemboLogo theme="dark" size="lg" /></Link>
        <div className="rl-auth__panel-copy">
          <h2 className="rl-auth__panel-title">Where beauty careers are built.</h2>
          <p className="rl-auth__panel-text">Connect skilled stylists, nail techs and makeup artists with the salons and studios hiring across Kenya.</p>
        </div>
        <p className="rl-auth__panel-foot">RemboList for the beauty industry</p>
      </aside>
      <div className="rl-auth__content">
        <header className="rl-auth__header">
          <Link to="/" aria-label="RemboList home"><RemboLogo theme="light" /></Link>
        </header>
        <main className="rl-auth__main">
          <div className={`rl-auth-card${wide ? " rl-auth-card--wide" : ""}`}>{children}</div>
          {footer && <p className="rl-auth__footer">{footer}</p>}
        </main>
      </div>
    </div>
  );
}

// Inline banner. tone: "error" (default) | "success" | "info".
export function AuthAlert({ tone = "error", children }) {
  const icon = tone === "success" ? "check-circle" : tone === "info" ? "info" : "alert-circle";
  return (
    <div className={`rl-auth-alert rl-auth-alert--${tone}`} role={tone === "error" ? "alert" : "status"}>
      <Icon name={icon} size={18} />
      <div>{children}</div>
    </div>
  );
}

// Big icon shown above the heading of a result state (sent, verified, failed).
export function AuthStatusIcon({ name, tone = "action" }) {
  return (
    <div className={`rl-auth-status-icon rl-auth-status-icon--${tone}`}>
      <Icon name={name} size={28} />
    </div>
  );
}

export function AuthDivider({ children = "or" }) {
  return <div className="rl-auth-divider"><span>{children}</span></div>;
}

export function AuthSpinner({ large = false }) {
  return <span className={`rl-auth-spinner${large ? " rl-auth-spinner--lg" : ""}`} role="status" aria-label="Loading" />;
}
